export enum ToastSeverity {
  Success,
  Warning,
  Error
}

export interface ToastDefinition {
  severity: ToastSeverity;
  message: string;
  id?: string;
}
